import { Button, Input } from '@material-tailwind/react'
import { useTranslation } from 'react-i18next'
import PropTypes from 'prop-types'
import { FiSearch } from 'react-icons/fi'
import { FilterPopover } from '@/shared/components/filter-popover'
import DebouncedInput from '@/shared/components/debounced-input'
import { useSearchParams } from 'react-router-dom'
import {
  AccreditationSelector,
  OfficeSelector,
  StatusSelector
} from '@/shared/selectors'

export const ContractFilter = () => {
  const [searchParams, setSearchParams] = useSearchParams()
  const { t } = useTranslation()

  const handleFilterChange = (name, value) => {
    if (value === '' || value === null || value === undefined) {
      searchParams.delete(name)
    } else {
      searchParams.set(name, value)
      searchParams.set('page', 1)
      searchParams.set('parents', true)
    }
    setSearchParams(searchParams)
  }

  const handleInputSearch = (value) => {
    handleFilterChange('q', value)
  }

  const cleanSearchParams = () => {
    searchParams.delete('q')
    searchParams.delete('by_office_id')
    searchParams.delete('by_status')
    searchParams.delete('by_accredited')
    setSearchParams(searchParams)

    setSearchParams((prevParams) => new URLSearchParams(prevParams))
  }

  return (
    <div className='flex gap gap-3'>
      <div>
        <DebouncedInput
          icon={<FiSearch />}
          name='q'
          label={t('contract.searcher.label')}
          onChange={handleInputSearch}
          value={searchParams.get('q') || ''}
          className='w-full sm:w-96'
        />
      </div>
      <FilterPopover>
        <div className='grid gap gap-4'>
          <div className='grid gap gap-2'>
            <StatusSelector
              onChange={(option) =>
                handleFilterChange('by_status', option ? option.value : '')
              }
              value={searchParams.get('by_status') || ''}
            />
          </div>
          <div className='grid gap gap-2'>
            <AccreditationSelector
              onChange={(option) =>
                handleFilterChange('by_accredited', option ? option.value : '')
              }
              value={searchParams.get('by_accredited') || ''}
            />
          </div>
          <div className='grid gap gap-2'>
            <OfficeSelector
              value={
                searchParams.get('by_office_id')
                  ? Number(searchParams.get('by_office_id'))
                  : ''
              }
              onChange={(option) =>
                handleFilterChange('by_office_id', option ? option.value : '')
              }
            />
          </div>

          <div className='flex justify-center mt-10'>
            <Button
              type='button'
              className='bg-color-white text-red-600 border-solid border-2 border-red-200 p-2'
              onClick={cleanSearchParams}
            >
              {t('filters.delete')}
            </Button>
          </div>
        </div>
      </FilterPopover>
    </div>
  )
}

ContractFilter.propTypes = {
  open: PropTypes.bool,
  handler: PropTypes.func
}
